import { render } from "./writingAssessmentPopup.vue?vue&type=template&id=607160f2&scoped=true"
import script from "./writingAssessmentPopup.vue?vue&type=script&lang=js"
export * from "./writingAssessmentPopup.vue?vue&type=script&lang=js"

import "./writingAssessmentPopup.vue?vue&type=style&index=0&id=607160f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607160f2"]])

export default __exports__